module.exports = __webpack_public_path__ + "img/Group 1566.adfe6ddd.svg";